module.exports = __webpack_public_path__ + "img/yf.10ede833.svg";